// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"47bfcc5e92da3dd80979a92d711050e5e9a2fdf3"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { commonClientConfig } from '@ethena/shared-ui/src/sentry/commonClientConfig'

import * as Sentry from '@sentry/nextjs'

Sentry.init({
  ...commonClientConfig,
})
